import React from 'react';
import { Alert } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LeadsTable from './table/index';
import {
  COLUMN_DEFINITIONS,
  LAST_ACTIVITY
} from './table/cell';
import TaskModal from './task_modal';
import LeadOptions from './lead_options';

import LoadingSpinner from 'components/ui/loading_spinner';
import SearchPage from 'components/search_page';
import CsvDownloadButton from 'components/csv_download_button';
import { retrieveRecords, filterOptionsAsQueryParameter } from './store/actions/search';
import { toggleAlert } from './store/actions/ui';
import { setColumns } from './store/actions/session';
import NewPageHeader from 'shared/page_header';
import Pagination from 'shared/pagination';
import LeadModal from '../modal';
import AllFiltersModal from './all_filters_modal';

import {
  changeBrokerFilter,
  changeReferralSourceFilter,
  changeSearchText,
  changeStatusFilter,
  changeWaitlistFilter,
  changeProfileUserTypeFilter,
  changePage,
  changeSort,
  clearFilters,
  changePropertyFilter,
  changeCaStatusFilter,
  changeCompanyFilter,
  changeStartDate,
  changeEndDate,
  changeMultipleFilters
} from './store/actions/query';

import { toggleAllFiltersModal } from './store/actions/ui';
import LeadFilterTopbar, {
  BROKER_TEAM_WAITLIST_STATUS_OPTIONS,
  CA_STATUS_OPTIONS,
  ROLE_OPTIONS
} from '../shared/lead_filter_topbar';
import LeadNoResults from '../shared/no_results';
import NoLeads from '../shared/no_leads';

// This represents the entire leads index page, except redux setup (LeadsIndex does that).
export class Leads extends React.Component {
  static propTypes = {
    alert: PropTypes.object.isRequired,
    clientReportActive: PropTypes.bool.isRequired,
    currentColumns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    currentPage: PropTypes.number.isRequired,
    defaultColumns: PropTypes.object.isRequired,
    features: PropTypes.shape({
      projectTasksActivities: PropTypes.bool.isRequired
    }),
    isFetchingLeads: PropTypes.bool.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    leads: PropTypes.array.isRequired,
    pageSize: PropTypes.number.isRequired,
    paths: PropTypes.shape({ leadsCsvPath: PropTypes.string.isRequired }).isRequired,
    query: PropTypes.shape({
      leadReferralSources: PropTypes.array.isRequired,
      leadStatuses: PropTypes.array.isRequired,
      searchText: PropTypes.string.isRequired,
      statusFilter: PropTypes.array.isRequired,
      sort: PropTypes.shape({
        column: PropTypes.string.isRequired,
        columnKey: PropTypes.string.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired
      }).isRequired
    }).isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    setColumns: PropTypes.func.isRequired,
    showAllFiltersModal: PropTypes.bool.isRequired,
    toggleAlert: PropTypes.func.isRequired,
    toggleAllFiltersModal: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onChangeBrokerFilter: PropTypes.func.isRequired,
    onChangeCaStatusFilter: PropTypes.func.isRequired,
    onChangeCompanyFilter: PropTypes.func.isRequired,
    onChangeEndDate: PropTypes.func.isRequired,
    onChangeMultipleFilters: PropTypes.func.isRequired,
    onChangeProfileUserTypeFilter: PropTypes.func.isRequired,
    onChangePropertyFilter: PropTypes.func.isRequired,
    onChangeReferralSourceFilter: PropTypes.func.isRequired,
    onChangeSearchText: PropTypes.func.isRequired,
    onChangeStartDate: PropTypes.func.isRequired,
    onChangeStatusFilter: PropTypes.func.isRequired,
    onChangeWaitlistFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onSortChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.retrieveRecords();
  }

  scrollPanel = React.createRef();

  handleSortChange = (columnKey) => {
    const newColumn = COLUMN_DEFINITIONS[columnKey].sortValue;
    const { column, order } = this.props.query.sort;
    const oldColumn = column;
    let newOrder = 'desc';

    if (oldColumn === newColumn) {
      newOrder = order === 'asc' ? 'desc' : 'asc';
    }

    this.props.onPageChange(1, { fetchRecords: false });
    this.props.onSortChange({ columnKey, column: newColumn, order: newOrder });
  };

  handlePageChange = page => this.props.onPageChange(page);

  handleDismissAlert = () => {
    this.props.toggleAlert('', false);
  };

  filterColumns(columns) {
    const { projectTasksActivities } = this.props.features;
    if (projectTasksActivities) return columns;

    return Object.keys(columns).reduce((columnsToKeep, column) => {
      if (column !== LAST_ACTIVITY) columnsToKeep[column] = columns[column];
      return columnsToKeep;
    }, {});
  }

  renderAlert() {
    const { error, message } = this.props.alert;
    if (!message) return;

    return (
      <Alert className="m-0" dismissible variant={error ? 'danger' : 'success'} onClose={this.handleDismissAlert}>
          <span>{message}</span>
      </Alert>
    );
  }

  render() {
    const { leadReferralSources, leadStatuses } = this.props.query;

    return (
      <React.Fragment>
        <SearchPage>
          <div className="results-tab-container">
            {this.renderAlert()}
            {this.renderPageHeader()}
            <LeadFilterTopbar
              currentPage={this.props.currentPage}
              leadCount={this.props.leads.length}
              pageSize={this.props.pageSize}
              toggleAllFiltersModal={this.props.toggleAllFiltersModal}
              totalCount={this.props.totalCount}
              totalPages={this.props.totalPages}
              onChangeBrokerFilter={this.props.onChangeBrokerFilter}
              onChangeCaStatusFilter={this.props.onChangeCaStatusFilter}
              onChangeCompanyFilter={this.props.onChangeCompanyFilter}
              onChangeEndDate={this.props.onChangeEndDate}
              onChangeProfileUserTypeFilter={this.props.onChangeProfileUserTypeFilter}
              onChangePropertyFilter={this.props.onChangePropertyFilter}
              onChangeReferralSourceFilter={this.props.onChangeReferralSourceFilter}
              onChangeSearchText={this.props.onChangeSearchText}
              onChangeStartDate={this.props.onChangeStartDate}
              onChangeStatusFilter={this.props.onChangeStatusFilter}
              onChangeWaitlistFilter={this.props.onChangeWaitlistFilter}
              onClearFilters={this.props.onClearFilters}
              {...this.props.query}
            />
            <div>
              <div className="main-content" ref={this.scrollPanel}>
                {this.renderResults()}
                {this.renderPagination()}
              </div>
            </div>
          </div>
        </SearchPage>
        <LeadModal leadReferralSources={leadReferralSources} leadStatuses={leadStatuses}/>
        <TaskModal/>
        {this.renderAllFiltersModal()}
      </React.Fragment>
    );
  }

  renderAllFiltersModal = () => {
    const query = this.props.query;
    const filters = {
      endDate: query.endDate,
      startDate: query.startDate,
      brokerFilter: query.brokerFilter,
      caStatusFilter: query.caStatusFilter,
      companyFilter: query.companyFilter,
      profileUserTypeFilter: query.profileUserTypeFilter,
      propertyFilter: query.propertyFilter,
      referralSourceFilter: query.referralSourceFilter,
      statusFilter: query.statusFilter,
      waitlistFilter: query.waitlistFilter
    };

    const dataForFilters = {
      brokers: query.brokers,
      companies: query.companies,
      leadReferralSources: query.leadReferralSources,
      leadStatuses: query.leadStatuses,
      properties: query.properties,
      profileUserTypes: ROLE_OPTIONS,
      caOptions: CA_STATUS_OPTIONS,
      waitlistOptions: BROKER_TEAM_WAITLIST_STATUS_OPTIONS
    };

    const dynamicFilters = [
      { dataKey: 'brokers', filterKey: 'brokerFilter', label: 'Brokers' },
      { dataKey: 'profileUserTypes', filterKey: 'profileUserTypeFilter', label: 'Roles / Job Title' },
      { dataKey: 'leadStatuses', filterKey: 'statusFilter', label: 'Lead Status' },
      { dataKey: 'caOptions', filterKey: 'caStatusFilter', label: 'CA Status' },
      { dataKey: 'waitlistOptions', filterKey: 'waitlistFilter', label: 'Waitlist Status' },
      { dataKey: 'leadReferralSources', filterKey: 'referralSourceFilter', label: 'Sources' },
      { dataKey: 'properties', filterKey: 'propertyFilter', label: 'Properties' },
      { dataKey: 'companies', filterKey: 'companyFilter', label: 'Companies' },
    ];

    return (
      <AllFiltersModal
        closeModal={this.props.toggleAllFiltersModal}
        dataForFilters={dataForFilters}
        dynamicFilters={dynamicFilters}
        show={this.props.showAllFiltersModal}
        staringFilters={filters}
        onChangeFilters={this.props.onChangeMultipleFilters}
      />
    );
  };

  csvDownloadPath() {
    const query = [];
    const filterParams = filterOptionsAsQueryParameter(this.props.query);
    Object.keys(filterParams).forEach((filterKey) => {
      const filterValue = filterParams[filterKey];
      if (Array.isArray(filterValue)) {
        filterValue.forEach(value => query.push(`${filterKey}[]=${value}`));
      } else {
        query.push(`${filterKey}=${filterValue}`);
      }
    });

    // we cannot send the order since it will get ignored by in_batches
    return `${this.props.paths.leadsCsvPath}?${query.join('&')}`;
  }

  renderPageHeader() {
    return (
      <NewPageHeader title="Leads">
        <CsvDownloadButton hasButtonToRight={false} href={this.csvDownloadPath()} type="Button"/>
      </NewPageHeader>
    );
  }

  renderLeadOptions = (lead) => {
    return <LeadOptions lead={lead}/>;
  };

  renderResults() {
    const { leads, isFetchingLeads, isFiltered, totalCount } = this.props;

    if (isFetchingLeads) {
      return (
        <div className="centered-image">
          <LoadingSpinner/>
        </div>
      );
    }

    if (leads.length > 0) {
      const { currentColumns, defaultColumns, query, setColumns } = this.props;
      const columnsToUse = Array.isArray(currentColumns) ? defaultColumns : currentColumns;

      return (
        <LeadsTable
          clientReportActive={this.props.clientReportActive}
          columns={this.filterColumns(columnsToUse)}
          defaultColumns={this.filterColumns(defaultColumns)}
          leads={leads}
          renderLeadOptions={this.renderLeadOptions}
          selectableLeadRowProps={() => ({ hideCheckbox: true })}
          sortColumn={query.sort.columnKey}
          sortDesc={query.sort.order === 'desc'}
          stickyColumns={1}
          onSetColumns={setColumns}
          onSort={this.handleSortChange}
        />
      );
    }

    if (totalCount === 0) {
      return (
        <div className="centered-image">
          {isFiltered ? (
            <LeadNoResults
              onClearFilters={this.props.onClearFilters}
            />
          ) : (
            <NoLeads
              emptyLeadsImage="/images/project_empty_states/leads.svg"
            />
          )}
        </div>
      );
    }
  }

  renderPagination() {
    const { isFetchingLeads, leads, totalCount } = this.props;
    if (isFetchingLeads) return;

    return (
      <div className="d-flex justify-content-center my-4">
        <Pagination
          currentPage={this.props.currentPage}
          totalPages={this.props.totalPages}
          onChange={this.handlePageChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const isFiltered = !(
    state.query.searchText === '' &&
    state.query.brokerFilter.length === 0 &&
    state.query.statusFilter.length === 0 &&
    state.query.waitlistFilter.length === 0 &&
    state.query.referralSourceFilter.length === 0 &&
    state.query.profileUserTypeFilter.length === 0 &&
    state.query.propertyFilter.length === 0 &&
    state.query.caStatusFilter.length === 0 &&
    state.query.companyFilter.length === 0 &&
    state.query.startDate == null &&
    state.query.endDate == null
  );

  return {
    ...state.search.meta,

    alert: { message: state.ui.alertMessage, error: state.ui.error },
    currentColumns: state.session.currentColumns,
    features: state.features,
    leads: state.search.leads,
    isFetchingLeads: state.search.isFetching,
    isFiltered,
    paths: state.paths,
    query: state.query,
    showAllFiltersModal: state.ui.showAllFiltersModal
  };
};

const mapDispatchToProps = {
  onPageChange: changePage,
  onSortChange: changeSort,
  retrieveRecords,
  setColumns,
  toggleAlert,
  onClearFilters: clearFilters,
  onChangeBrokerFilter: changeBrokerFilter,
  onChangeMultipleFilters: changeMultipleFilters,
  onChangeReferralSourceFilter: changeReferralSourceFilter,
  onChangeSearchText: changeSearchText,
  onChangeStatusFilter: changeStatusFilter,
  onChangeWaitlistFilter: changeWaitlistFilter,
  onChangeProfileUserTypeFilter: changeProfileUserTypeFilter,
  onChangePropertyFilter: changePropertyFilter,
  onChangeCaStatusFilter: changeCaStatusFilter,
  onChangeCompanyFilter: changeCompanyFilter,
  toggleAllFiltersModal,
  onChangeStartDate: changeStartDate,
  onChangeEndDate: changeEndDate
};

export default connect(mapStateToProps, mapDispatchToProps)(Leads);
